// extracted by mini-css-extract-plugin
export default {"emptyStateFooter":"styles_emptyStateFooter__Jkeab","footerDescription":"styles_footerDescription__RXz38","playGamesButton":"styles_playGamesButton__WAgXk"};